// src/Pages/contact-info/TermsConditions.jsx

import React, { useEffect, useState } from "react";
import "../../profile.css";

import { ArrowLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";

import service from "../../services/service";
import endpoints from "../../services/endpoints";
import { formatCmsHtml } from "../../utils/formatCmsHtml";

const TermsConditions = () => {
  const navigate = useNavigate();

  const [termsData, setTermsData] = useState(null);
  const [loading, setLoading] = useState(false);

  /* =========================
      GET TERMS & CONDITIONS
  ========================= */

  const getTermsConditions = async () => {
    try {
      setLoading(true);

      const response = await service.get(
        endpoints.cms.termsConditions,
      );
      console.log("Terms & Conditions Response:", response);

      setTermsData(response?.data?.data || null);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getTermsConditions();
  }, []);

  return (
    <div className="info-page">
      <div className="info-page-top">
        <ArrowLeft
          className="back-btn"
          onClick={() => navigate("/contact-info")}
        />

        <h2>Terms & Conditions</h2>
      </div>

      {loading ? (
        <p className="favourites-loading">
          Loading Terms & Conditions...
        </p>
      ) : (
        <div className="info-page-content">
          <div
            className="cms-html-content"
            dangerouslySetInnerHTML={{
              __html: formatCmsHtml(termsData || ""),
            }}
          />
        </div>
      )}
    </div>
  );
};

export default TermsConditions;